$(function() {
    $(".pf_text_in").keyup(function() {
        var pf_text_in = $(this).val();
        $(".text_preview1").val(pf_text_in);
		$(".text_preview2").val(pf_text_in);
		$(".text_preview3").val(pf_text_in);
		$(".text_preview4").val(pf_text_in);
		$(".text_preview5").val(pf_text_in);
		$(".text_preview6").val(pf_text_in);
		$(".text_preview7").val(pf_text_in);
		$(".text_preview8").val(pf_text_in);
		$(".text_preview9").val(pf_text_in);
		$(".text_preview10").val(pf_text_in);
		$(".text_preview11").val(pf_text_in);
		$(".text_preview12").val(pf_text_in);
		$(".text_preview13").val(pf_text_in);
		$(".text_preview14").val(pf_text_in);
		$(".text_preview15").val(pf_text_in);
        $(".text_preview16").val(pf_text_in);
		$(".text_preview17").val(pf_text_in);
		$(".text_preview18").val(pf_text_in);
		$(".text_preview19").val(pf_text_in);
		$(".text_preview20").val(pf_text_in);
		$(".text_preview21").val(pf_text_in);
		$(".text_preview22").val(pf_text_in);
		$(".text_preview23").val(pf_text_in);
		$(".text_preview24").val(pf_text_in);
		$(".text_preview25").val(pf_text_in);
		$(".text_preview26").val(pf_text_in);
		$(".text_preview27").val(pf_text_in);
		$(".text_preview28").val(pf_text_in);
		$(".text_preview29").val(pf_text_in);
		$(".text_preview30").val(pf_text_in);
      

        return false;
    });
});